import styled, { css } from 'styled-components';

export const SmallTextCss = css`
  font-family: ${props => props.theme.v2.fontFamily.default};
  font-style: normal;
  font-weight: normal;
  font-size: 12px;
  line-height: 19px;
`;

export default styled.span`
  ${SmallTextCss}
`;
